// components
import DisplayValue from "../DisplayValue";

// store
import { useSearchStore } from "store/searchStore";

// styles
import styles from "./OrganizationOwnershipSection.module.scss";

// utils
import {
  getSelfCertsLabel,
  splitByEveryOtherComma,
  getLegalStructureName,
} from "utils/helper";

export default function OrganizationOwnershipSection() {
  const { business_profile } = useSearchStore();

  return (
    <div className={styles["organization-ownership-root"]}>
      <h2
        className={styles["heading"]}
        id="organization-ownership"
        tabIndex={-1}
      >
        Organization & ownership
      </h2>

      <div className={styles["content"]}>
        <div className={styles["data-field"]}>
          <h5 className={styles["label"]}>Entity structure</h5>
          <DisplayValue
            messageElement="p"
            className={styles["value"]}
            value={getLegalStructureName(business_profile?.legal_structure)}
          />
        </div>

        <div className={styles["data-field"]}>
          <h5 className={styles["label"]}>Current Principals</h5>
          <DisplayValue
            messageElement={business_profile?.current_principals ? "ol" : "p"}
            className={styles["list"]}
            value={business_profile?.current_principals}
            renderer={(_value) => (
              <>
                {business_profile.current_principals
                  .split(";")
                  .map((p) => p.trim())
                  .map((principal, i) => {
                    return <li key={i}>{principal}</li>;
                  })}
              </>
            )}
          />
        </div>

        <div className={styles["data-field"]}>
          <h5 className={styles["label"]}>
            Business type & self-certifications
          </h5>
          <p className={styles["value"]}>
            Small businesses attested to these ownership traits when registering
            with SAM.gov. These attestations are not vetted by SBA.
          </p>

          {business_profile?.meili_self_certifications &&
          business_profile.meili_self_certifications.length > 0 ? (
            <>
              {
                <ul className={styles["list"]}>
                  {business_profile.meili_self_certifications.map((cert, i) => (
                    <li key={i}>{cert}</li>
                  ))}
                </ul>
              }
            </>
          ) : (
            <p className={styles["value"]}>No self-certifications found</p>
          )}
        </div>
      </div>
    </div>
  );
}
